import {
    REQUEST_DELETE_LIBRARY_CREATIVE,
    DELETE_LIBRARY_CREATIVE_SUCCESS,
    DELETE_LIBRARY_CREATIVE_ERROR,
} from './actionTypes';

export const requestDeleteLibraryCreative = () => ({
    type: REQUEST_DELETE_LIBRARY_CREATIVE,
});

export const deleteLibraryCreativeSuccess = creativeItem => ({
    type: DELETE_LIBRARY_CREATIVE_SUCCESS,
    payload: creativeItem,
});

export const deleteLibraryCreativeError = error => ({
    type: DELETE_LIBRARY_CREATIVE_ERROR,
    payload: error,
});
